/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCloudflareAccess = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.2 2.698a5.298 5.298 0 00-5.04 3.657l-.035.11H5.1l.022-.052a4.375 4.375 0 11.308 3.835l-.05-.088H4.358l.06.123A5.303 5.303 0 109.2 2.698z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.447 7.272L7.59 5.415l-.617.617 1.08 1.083H0l.52.872h8.63l.297-.715zM9.435 11.213l-.618-.618 1.08-1.082H1.425l-.518-.875h10.088l.298.717-1.858 1.857z"
}));

export default SvgCloudflareAccess;